<template>
  <div>
		<div class="page-container">
    <div class="page-title">
      <h1>Get in Touch <br class="mobile-break"> with DELKOIT</h1>
      <p>아래폼을 채워서 전송해 주시면, 당사의 고객 담당자가 연락을 드리겠습니다</p>
    </div>
    <form action="">
      <div class="form-grid">
        <InputComp label="First Name (이름)" required />
        <InputComp label="Last Name (성)" required />
        <InputComp label="Company (회사)" required />
        <InputComp label="Phone (전화번호)" required />
        <InputComp label="Email (이메일)" type="email" required />
      </div>
      <div class="form-row">
        <div class="label">귀사가 영위하는 주요 사업은 무엇인가요?</div>
        <div class="inner">
          <BtnCheckbox id="business1" text="증권사" />
          <BtnCheckbox id="business2" text="증권거래소" />
          <BtnCheckbox id="business3" text="투자자문 or 운용" />
          <BtnCheckbox id="business4" text="암호화폐 중개" />
          <BtnCheckbox id="business5" text="암호화폐 거래소" />
          <BtnCheckbox id="business6" text="기타" />
        </div>
      </div>

      <div class="form-row">
        <div class="label">어떤 제품이나 솔루션을 찾고 계신가요?</div>
        <div class="inner">
          <BtnCheckbox id="solution1" text="TAP Trader" />
          <BtnCheckbox id="solution2" text="DELKOIT HTS" />
          <BtnCheckbox id="solution3" text="OMS or RMS" />
          <BtnCheckbox id="solution4" text="S/W Development" />
          <BtnCheckbox id="solution5" text="Web Trader" />
          <BtnCheckbox id="solution6" text="Mobile App" />
          <BtnCheckbox id="solution7" text="ATS (Auto Trading)" />
          <BtnCheckbox id="solution8" text="기타" />
        </div>
      </div>
      <div class="form-row">
        <InputComp label="어떤 투자상품에 당사의 솔루션이 필요하신가요?" placeholder="Investment Assets 투자상품" />
      </div>
      <div class="form-row">
        <div class="label">다음 중 어떤 니즈를 가지고 계신가요?</div>
        <div class="inner">
          <BtnCheckbox id="needs1" text="기존 시스템을 교체하고 싶습니다." />
          <BtnCheckbox id="needs2" text="새로운 시스템 개발이 필요합니다." />
        </div>
      </div>
      <div class="form-row">
        <div class="label">다음 중 어떤 단계가 진행 중이신가요?</div>
        <div class="inner">
          <BtnCheckbox id="steps1" text="요구사항 협의 및 컨설팅이 필요한 초기 단계" />
          <BtnCheckbox id="steps2" text="명확한 요구사항이 정해진 단계" />
          <BtnCheckbox id="steps3" text="어떤 단계도 진행되지 않은 상태" />
        </div>
      </div>
      <div class="form-row">
        <div class="label">추가 코멘트</div>
        <InputTextAreaComp placeholder="Please provide any additional information" />
      </div>
      <BtnCheckbox
        id="agree"
        text="델코잇에 개인정보 제공과 델코잇의 <router-link to='' class='privacy-link'>개인정보정책</router-link>에 동의합니다."
      />
			<div class="submit-container">
				<BtnPrimary text="제출하기" />
			</div>
    </form>
  </div>
	</div>
</template>

<script>
import InputComp from '@/components/InputComp.vue';
import BtnCheckbox from '@/components/BtnCheckbox.vue';
import InputTextAreaComp from '@/components/InputTextAreaComp.vue';
import BtnPrimary from '@/components/BtnPrimary.vue';
export default {
  components: { InputComp, BtnCheckbox, InputTextAreaComp, BtnPrimary, },
  name: 'ContactFormPage',

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
